import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'

@Module({ namespaced: true, name: 'ImportacaoPagamentosStore' })
export default class ImportacaoPagamentosStore extends VuexModule {
  // ---- Lista de importações ----
  public importacoesList: any[] = []
  public pagina: number = 1
  public qtdPorPagina: number = 50
  public totalRegistros: number = 0
  public filtroStatus: any = null

  // ---- Nova importação ----
  public modalNovaImportacao: boolean = false

  // ---- Detalhe / itens da importação ----
  public modalDetalhe: boolean = false
  public importacaoSelecionada: any = null
  public itensList: any[] = []
  public itensPagina: number = 1
  public itensQtdPorPagina: number = 50
  public itensTotalRegistros: number = 0
  public itensFiltroStatus: any = null

  // ---- Liquidações de recebíveis ----
  public liquidacoesList: any[] = []
  public liqPagina: number = 1
  public liqQtdPorPagina: number = 50
  public liqTotalRegistros: number = 0
  public liqFiltroStatus: any = null
  public liqIdentificadorOrigem: any = null

  @Mutation
  setImportacoesList(value: any[]) {
    this.importacoesList = value
  }

  @Mutation
  setTotalRegistros(value: number) {
    this.totalRegistros = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setFiltroStatus(value: any) {
    this.filtroStatus = value
  }

  @Mutation
  setModalNovaImportacao(value: boolean) {
    this.modalNovaImportacao = value
  }

  @Mutation
  setModalDetalhe(value: boolean) {
    this.modalDetalhe = value
  }

  @Mutation
  setImportacaoSelecionada(value: any) {
    this.importacaoSelecionada = value
  }

  @Mutation
  setItensList(value: any[]) {
    this.itensList = value
  }

  @Mutation
  setItensTotalRegistros(value: number) {
    this.itensTotalRegistros = value
  }

  @Mutation
  setItensPagina(value: number) {
    this.itensPagina = value
  }

  @Mutation
  setItensFiltroStatus(value: any) {
    this.itensFiltroStatus = value
  }

  @Mutation
  resetItens() {
    this.itensList = []
    this.itensPagina = 1
    this.itensTotalRegistros = 0
    this.itensFiltroStatus = null
  }

  @Mutation
  setLiquidacoesList(value: any[]) {
    this.liquidacoesList = value
  }

  @Mutation
  setLiqTotalRegistros(value: number) {
    this.liqTotalRegistros = value
  }

  @Mutation
  setLiqPagina(value: number) {
    this.liqPagina = value
  }

  @Mutation
  setLiqFiltroStatus(value: any) {
    this.liqFiltroStatus = value
  }

  @Mutation
  setLiqIdentificadorOrigem(value: any) {
    this.liqIdentificadorOrigem = value
  }

  @Action
  async getImportacoes() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        status: this.filtroStatus,
      }
      const request = await Apis.RemuneracaoMedica.ImportacaoPagamentosApi.getImportacoes(params)
      if (request.success) {
        this.context.commit('setImportacoesList', request.data.itens || [])
        this.context.commit('setTotalRegistros', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async uploadArquivo(payload: { arquivo: any; tipoImportacao: string }) {
    try {
      const formData = new FormData()
      formData.append('arquivo', payload.arquivo)
      formData.append('tipoImportacao', payload.tipoImportacao)

      const request = await Apis.RemuneracaoMedica.ImportacaoPagamentosApi.uploadArquivo(formData)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao enviar o arquivo.' }
    }
  }

  @Action
  async getImportacaoItens() {
    try {
      if (!this.importacaoSelecionada) return { success: false }
      const params: any = {
        id: this.importacaoSelecionada.id,
        pagina: this.itensPagina,
        qtdPorPagina: this.itensQtdPorPagina,
        status: this.itensFiltroStatus,
      }
      const request = await Apis.RemuneracaoMedica.ImportacaoPagamentosApi.getImportacaoItens(params)
      if (request.success) {
        this.context.commit('setItensList', request.data.itens || [])
        this.context.commit('setItensTotalRegistros', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getLiquidacoes() {
    try {
      const params: any = {
        pagina: this.liqPagina,
        qtdPorPagina: this.liqQtdPorPagina,
        status: this.liqFiltroStatus,
        identificadorOrigem: this.liqIdentificadorOrigem,
      }
      const request = await Apis.RemuneracaoMedica.ImportacaoPagamentosApi.getLiquidacoesRecebiveis(params)
      if (request.success) {
        this.context.commit('setLiquidacoesList', request.data.itens || [])
        this.context.commit('setLiqTotalRegistros', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
